<template>
    <div class="text-ellipsis items-center text-black text-sm font-semibold col-auto leading-tight" role="rowheader">
        <slot></slot>
    </div>
</template>
